/* ---------------------------------------------------------------------------
   PB Forged: Add to Cart replaced by the brief, render and deposit journey.

   A set of forged wheels is 3,099 to 9,399 pounds, made to order, and the
   fitment has to be worked out before anything is cut. It is never bought in
   one tap, so on wheel pages there is no cart and no checkout. The customer
   configures in Avis, sends a brief, gets a render of their own car, then pays
   a 50% deposit on a Shopify draft order invoice.

   Why this file is defensive: Avis renders its OWN add to cart button and
   hides the theme's, and it re-renders on every option change. So we cannot
   simply remove the theme block, and we cannot bind once and walk away. We
   re-apply on mutation, intercept on the capture phase, and block the form
   submit as a backstop so a wheel can never be added to a cart even if the
   button relabel loses a race with Avis.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CFG = window.PBBrief;
  if (!CFG || !CFG.product) return;

  // 17 Oct 2026: catalogue listings (fixed Size and Finish variants) use this
  // same panel as a free design proof request. Bespoke pages keep the Avis brief.
  var CAT = CFG.mode === 'catalogue';
  var CTA_LABEL = CAT ? 'Get my free design proof' : 'See your wheels on your car';
  var SUB_LABEL = CAT ? 'Nothing to pay until you have seen your design' : 'Nothing to pay until you approve the design';

  var panel = document.getElementById('pb-brief');
  if (!panel) return;

  var sent = false;

  /* ---------------------------------------------------------------- utils */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function productForm() {
    if (CAT) {
      var main = $('.shopify-section--main-product form[action*="/cart/add"]');
      if (main) return main;
    }
    var forms = $$('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name^="properties["]')) return forms[i];
    }
    return forms[forms.length - 1] || null;
  }

  // Read the spec straight off Avis's own hidden inputs. This is the whole
  // reason this journey is cheap: Avis has already collected and validated it,
  // and the hidden inputs are written whatever widget type the option uses.
  // Catalogue listings: the spec is the selected Shopify variant, read from the
  // product form's id input and looked up in the variant list the snippet prints.
  function selectedVariant() {
    var form = productForm();
    var idEl = form ? form.querySelector('[name="id"]') : null;
    var id = idEl ? String(idEl.value) : '';
    if (!id) {
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m) id = m[1];
    }
    var vs = CFG.variants || [];
    for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === id) return vs[i]; }
    return vs[0] || null;
  }

  function catSpec() {
    var out = [];
    var v = selectedVariant();
    if (CFG.product.vehicle) out.push({ key: 'Vehicle', value: CFG.product.vehicle });
    if (CFG.product.design) out.push({ key: 'Design', value: CFG.product.design });
    if (v) {
      (CFG.optionNames || []).forEach(function (n, i) {
        if (v.options && v.options[i]) out.push({ key: n, value: v.options[i] });
      });
      out.push({ key: 'Price', value: v.priceFormatted + ' per set of four' });
    }
    return out;
  }

  function readSpec() {
    if (CAT) return catSpec();
    var form = productForm();
    var out = [];
    if (!form) return out;
    var seen = {};
    $$('[name^="properties["]', form).forEach(function (el) {
      if (el.disabled) return;
      var m = el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      var key = m[1];
      if (key.indexOf('_') === 0) return;
      var val = (el.value || '').trim();
      if (!val) return;
      if (/^(select|choose|please select)\b/i.test(val)) return;
      if (seen[key]) { seen[key].value += ', ' + val; return; }
      var row = { key: key, value: val };
      seen[key] = row;
      out.push(row);
    });
    return out;
  }

  // Which questions has the customer not answered? Derived from the option
  // containers on the page rather than the hidden input list, so free text
  // fields are never counted as gaps: they are optional.
  function norm(k) { return (k || '').trim().replace(/\?$/, '').toLowerCase(); }

  function unanswered() {
    if (CAT) return [];
    var answered = {};
    readSpec().forEach(function (row) { answered[norm(row.key)] = true; });
    var gaps = [];
    $$('.avp-option').forEach(function (c) {
      if (!c.querySelector('select, input[type="radio"], input[type="checkbox"]')) return;
      var t = c.querySelector('.apo-title');
      if (!t) return;
      var label = t.textContent.trim().replace(/\?$/, '');
      if (answered[norm(label)]) return;
      if (/anything/i.test(label)) return;
      gaps.push(label);
    });
    return gaps;
  }

  function livePrice() {
    var el = $('.shopify-section--main-product .price, .shopify-section--main-product price-list');
    var txt = el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var m = txt.match(/[£$€]\s?[\d,.]+/);
    if (m) return m[0].replace(/\s/g, '').replace(/[.,]00$/, '');
    return CFG.product.priceFormatted || '';
  }

  /* ------------------------------------------------------------- the CTA */

  function decorate(btn) {
    if (!btn || btn.getAttribute('data-pb-cta') === '1') return;
    btn.setAttribute('data-pb-cta', '1');
    btn.type = 'button';

    var price = CAT ? '' : livePrice();
    var label = CTA_LABEL + (price ? ' · from ' + price : '');
    var target = btn.querySelector('span, .button__text') || btn;
    target.textContent = label;

    if (btn.parentNode && !btn.parentNode.querySelector('.pb-brief__sub')) {
      var sub = document.createElement('p');
      sub.className = 'pb-brief__sub';
      sub.textContent = SUB_LABEL;
      btn.parentNode.insertBefore(sub, btn.nextSibling);

      // 17 Oct 2026: a direct line for questions, for buyers not ready to request a proof.
      var ask = document.createElement('p');
      ask.className = 'pb-brief__ask';
      var waText = 'Hi PB Forged, I have a question about the ' + CFG.product.title + ': ' + CFG.product.url;
      ask.innerHTML = 'Questions first? <a href="https://wa.me/447414099742?text=' + encodeURIComponent(waText)
        + '" target="_blank" rel="noopener">WhatsApp us</a> or <a href="mailto:info@pbforgedwheels.com?subject='
        + encodeURIComponent('Question: ' + CFG.product.title) + '">email us</a>.';
      sub.parentNode.insertBefore(ask, sub.nextSibling);
    }
  }

  // Catalogue listings: a live build summary above the button, so the customer
  // sees exactly what they are requesting a proof for before they tap it.
  function paintPageSummary() {
    if (!CAT) return;
    var bb = $('.shopify-section--main-product buy-buttons');
    if (!bb || !bb.parentNode) return;
    var box = document.getElementById('pb-build');
    if (!box) {
      box = document.createElement('div');
      box.id = 'pb-build';
      box.className = 'pb-build';
      box.innerHTML = '<div class="pb-build__t">Your build</div><dl class="pb-build__dl"></dl>'
        + '<div class="pb-build__see"><strong>See your design first</strong>'
        + '<p>A member of our team will be in touch to create your design proof: these wheels, in your chosen size and finish, on a photo of your own car. Nothing to pay until you have seen it and you are happy.</p></div>';
      bb.parentNode.insertBefore(box, bb);
    }
    var spec = readSpec();
    var sig = JSON.stringify(spec);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    var dl = box.querySelector('dl');
    dl.innerHTML = '';
    spec.forEach(function (row) {
      var dt = document.createElement('dt');
      dt.textContent = row.key;
      var dd = document.createElement('dd');
      dd.textContent = row.value;
      dl.appendChild(dt);
      dl.appendChild(dd);
    });
  }

  function decorateAll() {
    paintPageSummary();
    $$('.avis-new-addcart-button, .avis-org-addcart-button, .shopify-section--main-product buy-buttons button[type="submit"]')
      .forEach(decorate);
  }

  /* ------------------------------------------------- intercept everything */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(
      '.avis-new-addcart-button, .avis-org-addcart-button, [data-pb-cta="1"], .shopify-section--main-product buy-buttons button'
    );
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }, true);

  // Backstop: a wheel must never reach the cart. Scoped to the cart form so it
  // can never swallow the brief form's own submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
    }
  }, true);

  /* -------------------------------------------------------------- panel */

  function prefillCar() {
    var el = $('#pb-brief-car', panel);
    if (!el || el.value.trim()) return;
    if (CAT) {
      if (CFG.product.vehicle) el.value = CFG.product.vehicle + ' ';
      return;
    }
    var bits = [];
    readSpec().forEach(function (row) {
      if (/\bmake\b/i.test(row.key) || /\bmodel\b/i.test(row.key)) bits.push(row.value);
    });
    el.value = bits.join(' ');
  }

  function paintGaps() {
    var box = $('[data-pb-gaps]', panel);
    if (!box) return;
    var gaps = unanswered();
    if (!gaps.length) { box.hidden = true; return; }
    var pretty = gaps.map(function (g) { return g.replace(/\?$/, '').toLowerCase(); });
    $('[data-pb-gaps-list]', panel).textContent = pretty.join(', ');
    box.hidden = false;
  }

  function open() {
    if (sent) { showDone(); }
    paintSpec();
    paintGaps();
    prefillCar();
    panel.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    var first = $('#pb-brief-name', panel);
    if (first && !sent) setTimeout(function () { first.focus(); }, 60);
  }

  function close() {
    panel.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }

  function paintSpec() {
    var box = $('[data-pb-spec]', panel);
    var list = $('[data-pb-spec-list]', panel);
    if (!box || !list) return;
    var spec = readSpec();
    list.innerHTML = '';
    if (!spec.length) { box.hidden = true; return; }
    spec.forEach(function (row) {
      var dt = document.createElement('dt');
      dt.textContent = row.key.replace(/\?$/, '');
      var dd = document.createElement('dd');
      dd.textContent = row.value;
      list.appendChild(dt);
      list.appendChild(dd);
    });
    box.hidden = false;
  }

  function showDone() {
    $('[data-pb-step="form"]', panel).hidden = true;
    $('[data-pb-step="done"]', panel).hidden = false;
  }

  var back = $('[data-pb-back]', panel);
  if (back) back.addEventListener('click', function (e) { e.preventDefault(); close(); });

  $$('[data-pb-close]', panel).forEach(function (b) {
    b.addEventListener('click', close);
  });
  panel.addEventListener('click', function (e) { if (e.target === panel) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.hasAttribute('open')) close();
  });

  /* ------------------------------------------------------------- submit */

  function specText(spec) {
    var sv = CAT ? selectedVariant() : null;
    var lines = [
      CAT ? 'PB FORGED DESIGN PROOF REQUEST (catalogue listing, pay in full on approval)' : 'PB FORGED BUILD BRIEF',
      '',
      'Wheel: ' + CFG.product.title + ' (' + CFG.product.handle + ')',
      'Listed price: ' + ((sv && sv.priceFormatted) || CFG.product.priceFormatted || '') + ' per set of four',
      sv ? 'Variant ID: ' + sv.id : '',
      'Page: ' + CFG.product.url,
      ''
    ];
    spec.forEach(function (row) { lines.push(row.key + ': ' + row.value); });
    var gaps = unanswered();
    if (gaps.length) {
      lines.push('');
      lines.push('NOT ANSWERED, ask on the proof: ' + gaps.join(', '));
    }
    return lines.join('\n');
  }

  function toWorker(data, spec) {
    if (!CFG.worker) return;
    var fd = new FormData();
    var prod = CFG.product;
    if (CAT) {
      var sv = selectedVariant();
      prod = JSON.parse(JSON.stringify(CFG.product));
      if (sv) { prod.variantId = sv.id; prod.priceFormatted = sv.priceFormatted; }
    }
    fd.append('payload', JSON.stringify({
      source: CAT ? 'pbf-web-proof' : 'pbf-web',
      product: prod,
      customer: data,
      spec: spec,
      unanswered: unanswered()
    }));
    try { fetch(CFG.worker, { method: 'POST', body: fd, keepalive: true }); } catch (e) {}
  }

  // The form is a genuine Shopify contact form, so Shopify can attach its own
  // captcha token. A scripted fetch to /contact is rejected with 400 "Missing
  // CAPTCHA token", which is how the first version failed silently: fetch
  // resolves on a 400, so the panel said "Brief received" while nothing had
  // been sent. Nothing here claims success any more.
  var briefForm = document.getElementById('pb-brief-form');

  if (briefForm) briefForm.addEventListener('submit', function (e) {
    var err = $('[data-pb-err]', panel);
    var data = {
      name: ($('#pb-brief-name', panel).value || '').trim(),
      email: ($('#pb-brief-email', panel).value || '').trim(),
      phone: ($('#pb-brief-phone', panel).value || '').trim(),
      car: ($('#pb-brief-car', panel).value || '').trim(),
      country: $('#pb-brief-country', panel).value || ''
    };

    function fail(msg) {
      e.preventDefault();
      err.textContent = msg;
      err.hidden = false;
    }

    if (!data.name) return fail('We need a name to put on the render.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(data.email)) return fail('That email does not look right. The render goes to this address.');
    if (!data.car) return fail('We need the car, year included, to work out the fitment.');
    if (!data.country) return fail('Let us know where the wheels are going, so we can quote the freight.');
    if (!$('#pb-brief-consent', panel).checked) return fail('Please tick the box so we can reply to you.');

    err.hidden = true;

    var spec = readSpec();
    $('#pb-brief-body').value = specText(spec) +
      '\n\nCar: ' + data.car +
      '\nName: ' + data.name +
      '\nEmail: ' + data.email +
      '\nPhone: ' + (data.phone || 'not given') +
      '\nDelivery country: ' + data.country;

    try { sessionStorage.setItem('pbBriefName', data.name.split(' ')[0]); } catch (err2) {}

    toWorker(data, spec);
    track(CAT ? 'pbf_proof_request' : 'pbf_brief_submit', spec.length);

    var btn = $('[data-pb-submit]', panel);
    if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

    // Shopify's contact form is the one part of this journey we do not control,
    // and on this store it currently fails silently: the server demands a
    // captcha token and the storefront never loads the captcha that makes one.
    // So we never ASSUME it worked. If the page has not navigated within four
    // seconds the submit did not land, and the customer gets an honest message
    // and a one-tap email carrying the whole brief. A lead is never lost to a
    // form we cannot see inside.
    setTimeout(function () {
      if (!document.body) return;
      var subject = (CAT ? 'Design proof request: ' : 'Wheel brief: ') + CFG.product.title + ' for ' + data.car;
      var href = 'mailto:info@pbforgedwheels.com'
        + '?subject=' + encodeURIComponent(subject)
        + '&body=' + encodeURIComponent($('#pb-brief-body').value);
      err.innerHTML = 'That did not send. <a href="' + href + '">Email it to us instead</a>, '
        + 'or call 0121 630 3703. Your build details are already in the email.';
      err.hidden = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
    }, 4000);
  });

  // Shopify brings the customer back with ?contact_posted=true once it has
  // actually accepted the brief. That, not a fetch result, is the proof.
  if (/[?&]contact_posted=true/.test(location.search)) {
    sent = true;
    var fn = $('[data-pb-firstname]', panel);
    try {
      var n = sessionStorage.getItem('pbBriefName');
      if (fn && n) fn.textContent = ', ' + n;
      sessionStorage.removeItem('pbBriefName');
    } catch (e) {}
    showDone();
    panel.setAttribute('open', '');
  }

  function track(name, n) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          items: [{ item_id: CFG.product.handle, item_name: CFG.product.title }],
          value: CFG.product.price ? CFG.product.price / 100 : 0,
          currency: CFG.product.currency,
          spec_fields: n
        });
      }
    } catch (e) {}
  }

  /* ----------------------------------------------- Avis combo box labels
     Only applies to options still on a combo (multi-select) type. On single
     selection types this finds nothing and does nothing, which is correct.
  --------------------------------------------------------------------- */

  function render(ph, text, img) {
    var sig = (img ? img.getAttribute('src') : '') + '|' + text;
    if (ph.getAttribute('data-pb-v') === sig) return;
    ph.setAttribute('data-pb-v', sig);

    ph.textContent = '';
    if (img) {
      var i = document.createElement('img');
      i.className = 'pb-combo__img';
      i.src = img.getAttribute('src');
      i.alt = '';
      ph.appendChild(i);
    }
    ph.appendChild(document.createTextNode(text));
  }

  function promptFor(title) {
    if (!title) return '';
    var i = title.lastIndexOf(':');
    if (i !== -1) return 'Choose your ' + title.slice(i + 1).trim().toLowerCase();
    return 'Choose ' + title.toLowerCase();
  }

  function comboLabels() {
    $$('.avp-option').forEach(function (c) {
      var results = c.querySelector('.combo_option-results');
      var ph = c.querySelector('[class*="combo_"][class*="-placeholder"]');
      if (!results || !ph) return;

      var items = $$('.combo_option-result-item', results);
      var chips = items.map(function (it) {
        var t = it.querySelector('.choice-list-variatnt-title');
        return t ? t.textContent.trim() : '';
      }).filter(Boolean);

      var titleEl = c.querySelector('.apo-title');
      var title = titleEl ? titleEl.textContent.trim().replace(/\?$/, '') : '';

      if (chips.length === 1) {
        render(ph, chips[0], items[0].querySelector('img'));
        ph.classList.add('pb-combo--set');
        results.classList.add('pb-combo-hide');
      } else if (chips.length > 1) {
        render(ph, chips.length <= 3 ? chips.join(', ') : chips.length + ' selected', null);
        ph.classList.add('pb-combo--set');
        results.classList.remove('pb-combo-hide');
      } else {
        render(ph, promptFor(title), null);
        ph.classList.remove('pb-combo--set');
        results.classList.remove('pb-combo-hide');
      }
    });
  }

  /* ------------------------------------------- keep up with Avis redraws */

  decorateAll();
  comboLabels();
  var mo = new MutationObserver(function () { decorateAll(); comboLabels(); });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', function () { setTimeout(function () { decorateAll(); comboLabels(); }, 120); });
  setTimeout(function () { decorateAll(); comboLabels(); }, 1500);
  setTimeout(function () { decorateAll(); comboLabels(); }, 4000);
})();
